/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CancelPickupEmailContent
 */
export interface CancelPickupEmailContent {
  /**
   *
   * @type {string}
   * @memberof CancelPickupEmailContent
   */
  subject: string;
  /**
   *
   * @type {string}
   * @memberof CancelPickupEmailContent
   */
  body: string;
}

/**
 * Check if a given object implements the CancelPickupEmailContent interface.
 */
export function instanceOfCancelPickupEmailContent(
  value: object,
): value is CancelPickupEmailContent {
  if (!("subject" in value) || value["subject"] === undefined) return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  return true;
}

export function CancelPickupEmailContentFromJSON(
  json: any,
): CancelPickupEmailContent {
  return CancelPickupEmailContentFromJSONTyped(json, false);
}

export function CancelPickupEmailContentFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CancelPickupEmailContent {
  if (json == null) {
    return json;
  }
  return {
    subject: json["subject"],
    body: json["body"],
  };
}

export function CancelPickupEmailContentToJSON(
  json: any,
): CancelPickupEmailContent {
  return CancelPickupEmailContentToJSONTyped(json, false);
}

export function CancelPickupEmailContentToJSONTyped(
  value?: CancelPickupEmailContent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    subject: value["subject"],
    body: value["body"],
  };
}
